import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { ListChecksIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { usePurchaseOrderLineItem } from '@/api/rpc/hooks/accounts-payable/usePurchaseOrders';

interface PurchaseOrderLineItemInlineProps {
  entityType: SystemEntity;
  entityId: string;
  className?: string;
}

export function PurchaseOrderLineItemInline({
  entityId,
  className,
}: PurchaseOrderLineItemInlineProps) {
  const { lineItem, isLoading } = usePurchaseOrderLineItem(entityId);

  const displayName = isLoading
    ? '...'
    : lineItem
      ? `Line ${lineItem.lineNumber}`
      : 'Line Item';

  return (
    <HoverCard openDelay={200} closeDelay={200}>
      <HoverCardTrigger asChild>
        <div className="inline-block">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer text-xs', className)}
          >
            <ListChecksIcon className="size-3 shrink-0" />
            <span className="whitespace-nowrap">{displayName}</span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.INTERNAL_PURCHASE_ORDER_LINE_ITEM}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
